"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHeartOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12 20.994c-.297-.003-.63-.126-.996-.369C6.99 17.727 2 14.478 2 8.995 2 5.627 4.42 3 7.5 3c1.74 0 3.41.883 4.5 2.267C13.09 3.883 14.76 3 16.5 3 19.58 3 22 5.627 22 8.995c0 5.41-4.78 8.52-9.003 11.63-.367.25-.7.373-.997.37v-.001zm.002-1.944c3.01-2.633 7.998-5.726 8-10.055C20.002 7 18.602 5 16.502 5c-2.231 0-3.41 1.616-4.5 3-1.09-1.384-2.345-3-4.5-3-2.032 0-3.5 2.001-3.5 3.995-.002 4.329 5.01 7.46 8 10.055z' }))); };
exports.default = SvgHeartOutline;
//# sourceMappingURL=HeartOutline.js.map